//用这个，这个是最新的
import {
  request_productListInit,
  // request_productList,
  // getAllProducts,
} from '@/src/request/salesChannel/product';
import React from 'react';
import css from './css.module.less';
//import NoProduct from '../NoProduct';
import { Modal, ModalFooter } from '@/src/components/Antd';
//import Query from 'src/constrains/Query1';
//import Table from 'src/components/Antd/Table/Table';
import { useQueries } from '@/src/tools/hooks/listPageHooks';
import { Icon } from '@/src/tools/icon';
import { Spin } from 'antd';
import { get } from 'lodash';
import { useParams } from 'react-router-dom';
import { SizeFittingTable } from 'src/components/Antd';
import _Query, { EnumQueryType } from 'src/constrains/Query1';
import { useI18n } from 'src/hooks/useRouterChange';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { isArray } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import NoProduct from '../NoProduct';
import { filterList, salesChannelColumns } from './Col';
import GlobalPagination from '@/src/components/StyledPagination/GlobalPagination';
import { EnumSalesChannelMultiCurrency } from '@/src/types/server/params';

const syncChildrenCustomization = (products) => {
  return (products || []).map((p) => {
    const shopperProductCustomization = get(p, 'shopperProductCustomization');
    const children = get(p, 'children');
    if (!children) {
      return p;
    } else {
      const _children = (children || []).map((i) => {
        return {
          ...i,
          shopperProductCustomization:
            i.shopperProductCustomization || shopperProductCustomization,
        };
      });
      return { ...p, children: _children };
    }
  });
};

const _hideRow = '__row_hide';

const TableRow = (props) => {
  const { children, hide, ...rest } = props;

  const isHide = hide;

  //  console.log(rest);
  return isHide ? null : <tr {...rest}>{children}</tr>;
};

const symbol = '+++';

const isChild = (name) => {
  return name.indexOf(symbol) !== -1;
};

const generateChildrenUuid = (parentUuid, uuid) => {
  return `${parentUuid}${symbol}${uuid}`;
};

const splitName = (name) => {
  const [parent, child] = name.split(symbol);
  return { parent, child };
};

const getProduct = (products, targetUuid) => {
  let product = null;

  for (let i = 0; i < products.length; i++) {
    const { children, uuid } = products[i];

    if (uuid === targetUuid) {
      product = products[i];
      return product;
    }
    if (children) {
      const productInChild = getProduct(children, targetUuid) || {};
      if (productInChild.uuid) {
        product = productInChild;
        return product;
      }
    }
  }
  return product || {};
};

//convertDataFromState onOk输出数据整li
const convertDataFromState = (productsWithUuid, originalProducts) => {
  const parents = productsWithUuid
    .filter((i) => !isChild(i.uuid))
    .map((i) => {
      return { ...i, children: null };
    });
  const children = productsWithUuid.filter((i) => isChild(i.uuid));
  //product需要用_data
  const uuidTemp = children.reduce((pre, now) => {
    const { uuid } = now;
    const _isChild = isChild(uuid);
    if (_isChild) {
      const { child, parent } = splitName(uuid);
      const __self = { ...now, uuid: child };
      if (pre[parent]) {
        pre[parent] = [...pre[parent], __self];
      } else {
        pre[parent] = [__self];
      }
      return pre;
    } else {
      if (pre[uuid]) {
        return pre;
      } else {
        return { ...pre, [uuid]: [] };
      }
    }
  }, {});

  parents.forEach((i) => {
    const { uuid } = i;
    const _children = uuidTemp[uuid];
    i.children = _children;
  });
  //console.log(parents);
  return parents;
  // return parents;
  // return Object.keys(uuidTemp).map((key) => {
  //   const childrenUuids = uuidTemp[key] || [];
  //   const __self = getProduct(products, key) || {}; //convertDataFromState
  //   if (childrenUuids.length > 0) {
  //     const children = childrenUuids.map((i) => {
  //       return getProduct(products, i); //convertDataFromState
  //     });
  //     return { ...__self, children };
  //   } else {
  //     return __self;
  //   }
  // });
};

//=========网络请求数据uuid的处理
const convertServerData = (sources, nameSuffix?) => {
  return (sources || []).map((i) => {
    const { uuid, children } = i;
    const _uuid = nameSuffix ? generateChildrenUuid(nameSuffix, uuid) : uuid;
    if (children) {
      const _children = convertServerData(children, _uuid);
      return { ...i, uuid: _uuid, children: _children };
    } else {
      return { ...i, uuid: _uuid };
    }
  });
};

//=========props输入数据uuid的处理
const convertPropsData = (sources, canSelectChildren, nameSuffix?) => {
  return (sources || []).reduce((pre, i) => {
    const { uuid, children } = i;
    const _uuid = nameSuffix ? generateChildrenUuid(nameSuffix, uuid) : uuid;
    if (children) {
      const _childrenUuids = convertPropsData(
        children,
        canSelectChildren,
        _uuid,
      );
      if (canSelectChildren) {
        return [...pre, ..._childrenUuids];
      } else {
        return [...pre, ..._childrenUuids, _uuid];
      }
    } else {
      return [...pre, _uuid];
    }
  }, []);
};

const filterChildSelect = (prod) => {
  return prod.filter((i) => {
    return !isChild(i);
  });
};

//=========输出已被选择的sku,并且排除自己
const filterDuplicatedSku = (data, uuids) => {
  //
  // console.log('uuids', uuids);
  const skus = [];
  const _uuid = uuids.reduce((pre, i) => {
    // console.log('i', i);
    const product = getProduct(data, i); //data没问题u
    // console.log('product', product);
    const { sku } = product;
    if (!sku) {
      return [...pre, i];
    }
    const isOccupied = skus.includes(sku);
    if (isOccupied) {
      return pre;
    } else {
      skus.push(sku);
      return [...pre, i];
    }
  }, []);
  return _uuid;
};

const preProcessPropsProducts = (prod, canSelectChildren) => {
  return (prod || []).map((i) => {
    if (!canSelectChildren) return { ...i, children: null };
    return i;
  });
};

//const handleSelectedProducts = (allProducts, selectedUuid) => {};

const generateScrollProps = (products) => {
  if ((products || []).length > 5) {
    return { x: 'max-content', y: 360 };
  }
  return { x: 'max-content', y: 360 };
};

function _productVisibilityFilter() {
  this.filter = function (allProducts, currentProducts?) {
    // console.log('allProducts', allProducts);
    if (!currentProducts) {
      return allProducts.map((i) => {
        const { children, ...rest } = i;
        if (children) {
          const _children = this.filter(children);
          return { ...rest, children: _children, [_hideRow]: false };
        } else {
          return { ...rest, children: null, [_hideRow]: false };
        }
      });
    } else {
      //因为只比较第一级，不存在children uuid不同的问题
      const currentUuids = currentProducts.map((i) => i.uuid);
      return allProducts.map((i) => {
        const { uuid, children } = i;
        if (currentUuids.includes(uuid)) {
          //全可见
          if (children) {
            //这里先不做递归了，否则就是找出currentProducts的children 然后
            //children = productVisibilityFilter(children, currentChildren)
            const _children = this.setAllVisible(children);
            return { ...i, [_hideRow]: false, children: _children };
          } else {
            return { ...i, [_hideRow]: false, children: null };
          }
        } else {
          if (children) {
            const _children = this.setAllInvisible(children);
            return { ...i, [_hideRow]: true, children: _children };
          } else {
            return { ...i, [_hideRow]: true, children: null };
          }
        }
      });
    }
  };
}
_productVisibilityFilter.prototype.setAllInvisible = function (arr) {
  return (arr || []).map((i) => {
    return { ...i, [_hideRow]: true };
  });
};
_productVisibilityFilter.prototype.setAllVisible = function (arr) {
  return (arr || []).map((i) => {
    return { ...i, [_hideRow]: false };
  });
};
const productVisibilityFilter = new _productVisibilityFilter();

const getProductsValidUuid = (products) => {
  //如果有children，只会记录children的uuid，否组就自己
  return products.reduce((pre, product) => {
    const { uuid, children } = product;
    if (children) {
      const childrenUuid = getProductsValidUuid(children);
      return [...pre, ...childrenUuid];
    } else {
      return [...pre, uuid];
    }
  }, []);
};

const checkSelfShouldBeDisabled = ({
  uniqueSku,
  currentData,
  product,
  currentSkus,
  disabledUuids,
  currentSelected,
}) => {
  const { uuid, sku, children } = product;
  let shouldBeDisabled = false;
  const isHide = product[_hideRow];

  if (isHide && !(currentSelected || []).includes(uuid)) {
    shouldBeDisabled = true;
    return shouldBeDisabled;
  }
  const isUuidDisabled = disabledUuids.includes(uuid);
  if (isUuidDisabled) {
    shouldBeDisabled = true;
    return shouldBeDisabled;
  }
  if (uniqueSku && !shouldBeDisabled) {
    const isSkuOccupied = currentSkus.includes(sku);

    if (isSkuOccupied) {
      const currentSkuUuidProduct = currentData.find((i) => {
        const { sku: cSku } = i;
        return sku === cSku;
      });
      if (currentSkuUuidProduct) {
        const { uuid: cUuid } = currentSkuUuidProduct;

        if (cUuid !== uuid) {
          shouldBeDisabled = true;
          return shouldBeDisabled;
        }
      }
    }
  }
  if (shouldBeDisabled) {
    return true;
  } else {
    if (children) {
      //检查完自己，检查儿子们
      for (let i = 0; i < children.length; i++) {
        const _disable = checkSelfShouldBeDisabled({
          uniqueSku,
          currentData,
          product: children[i],
          currentSkus,
          disabledUuids,
          currentSelected,
        });
        if (!_disable) {
          //只要有一个不是disable 爸爸就还可以选
          return false;
        }
      }
      return true; //children都disabled了，父亲也disabled
    } else {
      return false;
    }
  }
};

const customerConvertQuery = (filter) => {
  const re: any = {};
  if (filter.tags) {
    if (filter.tags.length > 0) {
      re.tags = filter.tags.map((i) => {
        const { value } = i;
        return { uuid: value };
      });
    }
  }
  if (filter.alias) {
    if (filter.alias.length > 0) {
      re.alias = filter.alias[0].value == 'alias-1' ? true : false;
    }
  }
  if (filter.visible) {
    if (filter.visible.length > 0) {
      re.visible = filter.visible[0].value == 'visible-1' ? true : false;
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};

const getNotCurrentPageItems = (items, currentPageUuids) => {
  return items.filter((item) => !currentPageUuids.includes(item.uuid || item));
};

const getProductsFromUuids = (uuids, data) => {
  return uuids.reduce((acc, uuid) => {
    const product = getProduct(data, uuid);
    if (!product) return acc;

    if (isChild(uuid)) {
      const { parent } = splitName(uuid);
      const parentProduct = getProduct(data, parent);
      return [...acc, product, parentProduct];
    }
    return [...acc, product];
  }, []);
};

const mergeAndDeduplicateProducts = (currentProducts, previousProducts) => {
  return [...currentProducts, ...previousProducts].reduce((acc, curr) => {
    if (!acc.find((item) => item.uuid === curr.uuid)) {
      acc.push(curr);
    }
    return acc;
  }, []);
};

const GeneralSalesChannelProductSelection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    salesChannelUuid: _sUuid,
    visible,
    onOk,
    onCancel,
    selectedProducts,
    canSelectChildren,
    uniqueSku,
    okText, //非必需
    cancelText, //非必需
    disabledProducts, //要求multiple的爸爸 一定不能有sku, []
    type,
    customQueryProps = {},
    customColumns,
    showCustomisation, //是否返回专属定制
    initialSearchProps = {},
    pageSize = 60,
    showPagination = true,
    withMultiCurrency = false,
  } = props;

  const [loading, setLoading] = React.useState(true);
  const [pagination, setPagination] = React.useState({
    current: 0,
    pageSize: pageSize,
    total: 0,
  });

  const params: any = useParams();
  // console.log('_sUuid', _sUuid);
  const transUuidFromOldVersion = _sUuid
    ? isArray(_sUuid)
      ? _sUuid
      : [_sUuid]
    : null;
  //console.log('transUuidFromOldVersion', transUuidFromOldVersion);
  const salesChannelUuidInParas = params.saleChannelUuid || params.uuid;
  const salesChannelUuid = transUuidFromOldVersion || [salesChannelUuidInParas];
  //console.log('salesChannelUuidInParas', salesChannelUuidInParas);
  const _manualDisabledProducts = React.useMemo(() => {
    const p = (disabledProducts || []).map((i) => {
      const { children } = i;
      if ((children || []).length > 0) {
        return { ...i, sku: null };
      }
      return i;
    });
    const _convert = convertServerData(p || []);
    return _convert;
  }, [disabledProducts]);

  const _manualDisabledProductsValidUuids = React.useMemo(() => {
    return getProductsValidUuid(_manualDisabledProducts);
  }, [_manualDisabledProducts]);
  // console.log(
  //   '_manualDisabledProductsValidUuids',
  //   _manualDisabledProductsValidUuids,
  // );
  const _selectedProducts = React.useMemo(() => {
    return preProcessPropsProducts(selectedProducts, canSelectChildren);
  }, [selectedProducts, canSelectChildren]);

  const [tags, setTagList] = React.useState([]);
  // const [filters, setFilters] = React.useState([]);

  const [product, setProduct] = React.useState([]);
  //console.log('product', product);

  const initialSortBy = initialSearchProps?.sortBy ?? null;
  const initialCurrency = initialSearchProps?.currencyCode ?? null;

  const [sortBy, setSortBy] = React.useState(initialSortBy);
  const [currency] = React.useState(initialCurrency);

  const _data = React.useMemo(() => {
    return convertServerData(product);
  }, [product]);
  const _currentPageUuids = React.useMemo(() => {
    const getChildrensUuids = (arr) => {
      return arr.reduce((result, item) => {
        return [
          ...result,
          item.uuid,
          ...(item.children ? getChildrensUuids(item.children) : []),
        ];
      }, []);
    };
    return getChildrensUuids(_data);
  }, [_data]);

  // const _tableData = React.useMemo(() => {
  //   return _data.filter((i) => !i[_hideRow]);
  // }, [_data]);

  const [init, setHasInit] = React.useState(false);

  const isAllInvisible = React.useMemo(() => {
    return !(_data.filter((i) => !i[_hideRow]).length > 0) && init;
  }, [_data, init]);
  // console.log(' _selectedProducts', _selectedProducts);
  // console.log(
  //   ' convertPropsData(_selectedProducts)',
  //   convertPropsData(_selectedProducts, canSelectChildren),
  // );

  const [currentSelected, setCurrentSelected] = React.useState(
    convertPropsData(_selectedProducts, canSelectChildren),
  );
  const [currentSelectedProductsCache, setCurrentSelectedProductsCache] =
    React.useState(convertServerData(_selectedProducts) || []);
  const { queryProps, search } = useQueries(
    customQueryProps.filters
      ? customQueryProps.filters({ tags, getI18n })
      : filterList({ tags, getI18n }),
    [],
    customQueryProps.customerConvertQuery || customerConvertQuery,
  );

  const currentData =
    React.useMemo(() => {
      return currentSelected.map((i) => {
        return getProduct(_data, i); //ok
      });
    }, [currentSelected, _data]) || [];

  const currentSkus = React.useMemo(() => {
    return currentData.reduce((pre, i) => {
      if (i.sku) {
        return [...pre, i.sku];
      }
      return pre;
    }, []);
  }, [currentData]);

  const rowSelection = {
    type: type || 'checkbox',
    hideSelectAll: true || uniqueSku || isAllInvisible,
    selectedRowKeys: currentSelected,
    onChange: (products) => {
      const prod = products.reduce((pre, now) => {
        const product = getProduct(_data, now); //ok
        const isInvisible = get(product, _hideRow);
        const uuid = get(product, 'uuid');

        if (isInvisible && !currentSelected.includes(uuid)) {
          return pre;
        }
        return [...pre, now];
      }, []);
      let uuids = [];
      //不能选儿子的时候 用parent控制selectedItem，
      //反之 用儿子控制parent
      if (canSelectChildren) {
        if (uniqueSku) {
          const _uuid = filterDuplicatedSku(_data, prod);
          uuids = _uuid;
        } else {
          uuids = prod;
        }
      } else {
        const p = filterChildSelect(prod);

        if (uniqueSku) {
          const _uuid = filterDuplicatedSku(_data, p);
          uuids = _uuid;
        } else {
          uuids = p;
          setCurrentSelected((pre) => {
            const notCurrentPageUuids = getNotCurrentPageItems(
              pre,
              _currentPageUuids,
            );
            return type === 'radio'
              ? uuids
              : [...(uuids || []), ...(notCurrentPageUuids || [])];
          });
          setCurrentSelectedProductsCache((pre) => {
            const notCurrentPageProducts = getNotCurrentPageItems(
              pre,
              _currentPageUuids,
            );
            const uuidProducts = getProductsFromUuids(uuids, _data);
            return type === 'radio'
              ? uuidProducts
              : mergeAndDeduplicateProducts(
                  uuidProducts,
                  notCurrentPageProducts,
                );
          });
          return;
        }
      }
      const _currentData = uuids.map((i) => {
        return getProduct(_data, i); //ok
      });
      const _currentSkus = _currentData.reduce((pre, i) => {
        if (i.sku) {
          return [...pre, i.sku];
        }
        return pre;
      }, []);
      const worked = uuids.filter((proUuid) => {
        const product = getProduct(_data, proUuid); //ok

        const a = checkSelfShouldBeDisabled({
          product,
          uniqueSku,
          currentData: _currentData,
          currentSkus: _currentSkus,
          disabledUuids: _manualDisabledProductsValidUuids,
          currentSelected,
        }); //如果儿子们都是disabled了，自己也要disable

        return !a;
      });

      const filterParentUuid = worked.reduce((pre, now) => {
        const _isChild = isChild(now);
        if (_isChild) {
          return [...pre, now];
        }
        const product = getProduct(_data, now); //ok
        const { children } = product;
        if (!children) {
          return [...pre, now]; //过滤爸爸
        }
        return pre;
      }, []);

      // console.log('worked', worked);
      setCurrentSelected((pre) => {
        const notCurrentPageUuids = getNotCurrentPageItems(
          pre,
          _currentPageUuids,
        );
        return type === 'radio'
          ? filterParentUuid
          : [...(filterParentUuid || []), ...(notCurrentPageUuids || [])];
      });
      setCurrentSelectedProductsCache((pre) => {
        const notCurrentPageProducts = getNotCurrentPageItems(
          pre,
          _currentPageUuids,
        );
        const fpUuoidProducts = getProductsFromUuids(filterParentUuid, _data);
        return type === 'radio'
          ? fpUuoidProducts
          : mergeAndDeduplicateProducts(
              fpUuoidProducts,
              notCurrentPageProducts,
            );
      });
    },
    getCheckboxProps: (record) => {
      if (canSelectChildren) {
        const shouldBeDisabled = checkSelfShouldBeDisabled({
          product: record,
          uniqueSku,
          currentData,
          currentSkus,
          disabledUuids: _manualDisabledProductsValidUuids,
          currentSelected,
        });
        return { disabled: shouldBeDisabled };
      } else {
        const { uuid } = record;
        const _isChild = isChild(uuid);
        if (_isChild) {
          return { disabled: true };
        } else {
          const shouldBeDisabled = checkSelfShouldBeDisabled({
            product: record,
            uniqueSku,
            currentData,
            currentSkus,
            disabledUuids: _manualDisabledProductsValidUuids,
            currentSelected,
          });
          return { disabled: shouldBeDisabled };
        }
      }
    },
  };

  useAfterDidMountEffect(() => {
    // console.log('search 导致的update');

    if (pagination.current === 0) {
      fetchProducts();
    } else {
      setPagination((prev) => ({ ...prev, current: 0 }));
    }
  }, [search, showCustomisation, sortBy]);

  const fetchProducts = () => {
    setLoading(true);
    const searchProps = init ? search : initialSearchProps;
    const { current, pageSize } = pagination;

    const startIndex = current * pageSize;
    const maxCount = pageSize;
    request_productListInit(
      salesChannelUuid || [],
      startIndex,
      maxCount,
      {
        ...(searchProps || {}),
        showCustomisation,
        // Add sortBy to request body if it exists
        ...(sortBy ? { sortBy } : {}),
        ...(currency ? { currencyCode: currency } : {}),
      },
      withMultiCurrency
        ? {
            [EnumSalesChannelMultiCurrency.multiCurrencyInParams]: true,
          }
        : {},
    ).then((res) => {
      const {
        tags = [],
        // collections = [],
        products,
      } = res;
      const { results, totalCount } = products;
      setTagList(tags);

      const _data = productVisibilityFilter.filter(results || []); //要做 如果sort从服务器拿 有序
      setProduct(syncChildrenCustomization(_data));
      setPagination((prev) => ({
        ...prev,
        total: totalCount || 0,
      }));
      if (!init) setHasInit(true);
      setLoading(false);
    });
  };

  useAfterDidMountEffect(() => {
    fetchProducts();
  }, [pagination.current, pagination.pageSize]);

  React.useEffect(() => {
    fetchProducts();
  }, []);

  const scrollProps = React.useMemo(() => {
    return generateScrollProps(product);
  }, [(product || []).length]);

  // console.log('_data', _data);
  //console.log('isAllInvisible', isAllInvisible);
  const components = React.useMemo(() => {
    return {
      body: {
        row: (p) => {
          const _key = p['data-row-key'];
          const data = getProduct(_data, _key); //ok
          const shouldHide = data[_hideRow];
          const _props = { ...p, hide: shouldHide };

          // if (isAllInvisible) {
          //   return <tr {...p}>123</tr>;
          // }
          return <TableRow {..._props} />;
        },
      },
    };
  }, [_data]);

  const handleOnSearchChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ search: e, type: EnumQueryType.search });
    }
  };

  const handleOnFilterChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ filter: e, type: EnumQueryType.filter });
    }
  };

  const handleOnSortChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ sort: e, type: EnumQueryType.sort });
    }
  };

  const handleOnSearchClose = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ item: e, type: EnumQueryType.closeTag });
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter && sorter.field) {
      setSortBy(
        sorter.order
          ? {
              field: sorter.field,
              ascent: sorter.order === 'ascend',
            }
          : null,
      );
    }

    const { current, pageSize } = pagination;
    if (typeof current === 'number' && typeof pageSize === 'number') {
      setPagination((prev) => ({ ...prev, current, pageSize }));
    }
  };

  const pageOnChange = (index) => {
    if (index && index > 0) {
      setPagination((prev) => ({ ...prev, current: index - 1 }));
    }
  };

  const pageSizeChange = (size) => {
    setPagination((prev) => ({ ...prev, pageSize: size.value, current: 0 }));
  };

  return (
    <Modal
      title={getI18n('general.selectProduct')}
      visible={visible}
      width={900}
      onCancel={onCancel}>
      <Spin spinning={loading}>
        <div className={css.tableContainer}>
          <div className={css.queryContainer}>
            <_Query
              onSearchChange={handleOnSearchChange}
              onFilterChange={handleOnFilterChange}
              onSortChange={handleOnSortChange}
              onTagClose={handleOnSearchClose}
              filters={queryProps.filters || []}
              sortList={queryProps.sortList || []}
              data={queryProps.searchConditions || []}
            />
          </div>
          {init && product.length === 0 ? (
            <NoProduct link={`/salesChannel/products/${salesChannelUuid}`} />
          ) : (
            init && (
              <>
                <SizeFittingTable
                  className={`${css.table} ${
                    canSelectChildren ? '' : css.hideSelectSpace
                  } ${isAllInvisible ? css.allInvisible : ''}`}
                  id='ProductSetProductsSelectionTable'
                  columns={customColumns || salesChannelColumns({ getI18n })}
                  rowKey='uuid'
                  pagination={false}
                  dataSource={_data}
                  components={components}
                  rowSelection={{
                    ...rowSelection,
                    checkStrictly: canSelectChildren ? false : true,
                  }}
                  scroll={scrollProps}
                  onChange={handleTableChange}
                  sortDirections={['ascend', 'descend', null]}
                  expandable={{
                    indentSize: 16,
                    expandIcon: ({ expanded, onExpand, record }) => {
                      if (record.children) {
                        return expanded ? (
                          <Icon
                            onClick={(e) => onExpand(record, e)}
                            className={css.expandIcon}
                            type='iconleft'
                            style={{ transform: 'rotate(270deg)' }}
                          />
                        ) : (
                          <Icon
                            type='iconleft'
                            onClick={(e) => onExpand(record, e)}
                            className={css.expandIcon}
                            style={{ transform: 'rotate(180deg)' }}
                          />
                        );
                      }
                      return null;
                    },
                  }}
                />
                {showPagination ? (
                  <GlobalPagination
                    current={pagination.current + 1}
                    total={pagination.total}
                    pageSize={pagination.pageSize}
                    pageOnChange={pageOnChange}
                    pageSizeChange={pageSizeChange}
                    paginationProps={{ defaultPageSize: pageSize }}
                  />
                ) : (
                  ''
                )}
              </>
            )
          )}
        </div>
        <ModalFooter
          front={
            <div className={css.footerTip}>{`${
              (currentSelected || []).length
            } ${getI18n('general.itemsselected')}`}</div>
          }
          hideOkButton={!(currentSelected || []).length}
          okText={okText || getI18n('general.confirm')}
          cancelText={cancelText || getI18n('general.cancel')}
          onOk={() => {
            //因为可以选儿子的情况下，没有父亲，先把父亲放到里面
            const preProcessing = currentSelected.reduce((pre, now) => {
              if (!now) return pre;
              if (isChild(now)) {
                const { parent } = splitName(now);
                if (pre.includes(parent)) {
                  return [...pre, now];
                }
                return [...pre, now, parent];
              }
              return [...pre, now];
            }, []);

            const p = preProcessing.map((i) =>
              getProduct(currentSelectedProductsCache, i),
            );
            const products = convertDataFromState(p, product);
            if (onOk) onOk(products);
            if (onCancel) onCancel();
          }}
          onCancel={onCancel}
        />
      </Spin>
    </Modal>
  );
};
export default GeneralSalesChannelProductSelection;
